const content = {
  aboutIntro:
    "At Clevanoo LLC, we are a results-driven IT staffing and recruitment firm dedicated to connecting top-tier technology talent with forward-thinking companies across industries.",
  ourStory:
    "Founded by a team of seasoned IT professionals and experienced staffing experts, Clevanoo was built on a dual-perspective approach—valuing technical expertise just as much as the human element.\n\nWe understand that successful hiring is about more than just filling roles; it’s about building lasting partnerships that fuel innovation and growth.",
  highlights: [
    {
      title: "Personalized Staffing",
      text: "Tailored staffing solutions and relationship-focused partnerships.",
      icon: "👥",
    },
    {
      title: "Top Tech Talent",
      text: "Access to software engineers, cloud architects, data scientists and more.",
      icon: "💻",
    },
    {
      title: "AI-Powered Matching",
      text: "AI driven matching to reduce time-to-hire and increase retention.",
      icon: "🤖",
    },
    {
      title: "Workforce Consulting",
      text: "Market insights, salary benchmarks, and hiring strategy guidance.",
      icon: "📊",
    },
  ],
  services: [
    {
      title: "IT Staffing & Talent Solutions",
      text: "Contract, contract-to-hire, and direct placement services across disciplines.",
    },
    {
      title: "AI-Powered Talent Matching",
      text: "Intelligent platform that matches roles with precision and cultural fit.",
    },
    {
      title: "Workforce Consulting",
      text: "Strategic staffing guidance and tailored hiring strategies.",
    },
  ],
};

export default content;
